import _ from "lodash";
import dp from "dompurify";
import stringSimilarity from 'string-similarity';

export const featuresGroupByType = (features) => {
  return _.groupBy(features, (item) => item.type);
};

export const sanitizeText = (text) => {
  let cleanedText = "";
  if (text) {
    // Remove unwanted escape characters
    cleanedText = text.replace(/\\n\\/g, " "); // Normalize newlines and slashes

    // Trim excessive whitespace
    cleanedText = cleanedText.replace(/\s+/g, " ").trim();

    // Escape potentially unsafe HTML content
    cleanedText = dp.sanitize(cleanedText);
  }

  return cleanedText;
};

// To support antd form list validation
export const __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };

export const __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };

export const isEqualOnCommonFields = (obj1, obj2) => {
  if (!obj1 || !obj2) return false;
  
  const sharedKeys = _.intersection(Object.keys(obj1), Object.keys(obj2));

  const pickShared = (obj) => _.pick(obj, sharedKeys);

  return _.isEqual(pickShared(obj1), pickShared(obj2));
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const findDeep = (collection, predicate, childrenKey = "children") => {
  for (const item of collection) {
    if (fuzzyIsMatch(item, predicate)) {
      return item;
    }
    if (item[childrenKey]) {
      const found = findDeep(item[childrenKey], predicate, childrenKey);
      if (found) return found;
    }
  }
  return undefined;
};

function fuzzyIsMatch(object, source, options = {}) {
  const {
    threshold = 0.8, // similarity threshold (0 to 1)
    caseInsensitive = true,
    fuzzyKeys = Object.keys(source), // keys to apply fuzzy matching on
  } = options;

  return _.every(source, (srcVal, key) => {
    const objVal = _.get(object, key);

    if (!fuzzyKeys.includes(key)) {
      return _.isEqual(objVal, srcVal);
    }

    if (typeof srcVal === 'string' && typeof objVal === 'string') {
      const a = caseInsensitive ? srcVal.toLowerCase() : srcVal;
      const b = caseInsensitive ? objVal.toLowerCase() : objVal;
      const similarity = stringSimilarity.compareTwoStrings(a, b);
      return similarity >= threshold;
    }

    return _.isEqual(objVal, srcVal);
  });
}

export const getError = (error) => {
  const message = error?.response?.data?.errors
    .map((message) => message)
    .join(", ");
  return {
    description: message,
    message: `${error?.response?.data?.code} ${error?.response?.data?.status}`,
  };
};
